.ak{padding:0.5rem;}